import app from './app';
import view from 'bundle-text:../dom/signIn.html'; // eslint-disable-line

export default () => {
  app.route = 'signIn';

  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'h-auto',
    'justify-content-center',
    'mh-100',
    'w-100',
  );

  content.innerHTML = view;

  const title = `${app.run.settings.view.signIn.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
  document.title = title;

  const form = content.querySelector('#app-form-signIn');
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const data = {};
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      data[key] = value;
    });

    const json = JSON.stringify(data);

    console.log(formData);
    console.log(data);
    console.log(json);

    const request = new Request(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    });

    fetch(request)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
    }).catch((error) => {
        console.error(error);
        console.log('SATAN!');

        document.getElementById('view-signIn-error').innerHTML = `<h5><i class="fa-solid fa-fw fa-triangle-exclamation"></i> Sign in failed!</h5> ${error}`;
        document.getElementById('view-signIn-error').classList.remove('d-none');
  });

    /*
    fetch(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    }).then((response) => response.json())
    .then((data) => {
        console.log(data);
    });
    */

    /*
    fetch(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    }).then(async (response) => {
      const json = await response.json();

      if (json) {
        console.log('JSON OK!');
        console.log(json);
        content.querySelector('#view-signIn-error').innerHTML = json.error.text;
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      } else {
        console.log('NOT JSON OK!');
      }

      /*
      if (!response.ok) {
        if (response.json()) {
          console.log('YES, JSON!');
        } else {
          console.log('NOT!');
        }
        content.querySelector('#view-signIn-error').innerHTML = 'Everything went to shit!';
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      } else {
        content.querySelector('#view-signIn-error').innerHTML = 'Everything went to shit!';
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      }
      console.log(response);
      */
     /*
    });
    */
  });

  return content;
};
